<template>
    <div>
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;height: 100%;">
                            <p class="pTitle">账号信息</p>
                            <el-row class="infoPanel">
                                <el-col :span="14">
                                    <p v-if="userInfo.mobile">验证手机：<span style="color: #00a4e0;">{{
                                            userInfo.mobile | mobileSafety
                                        }}</span> 已验证</p>
                                    <p v-if="!userInfo.mobile">验证手机：未验证</p>
                                    <p style="color: #999999;">可用手机号加密码登录恒点MOOL，可通过手机号找回密码</p>
                                </el-col>
                                <el-col :span="10" style="text-align: right;">
                                    <el-button v-if="userInfo.mobile" type="primary" plain="plain" size="mini"
                                               style="position: relative;top:30px;" @click="changeMobile()">更换号码
                                    </el-button>
                                    <el-button v-if="!userInfo.mobile" type="primary" plain="plain" size="mini"
                                               style="position: relative;top:30px;" @click="setMobile()">设置号码
                                    </el-button>
                                </el-col>
                            </el-row>
                            <el-row class="infoPanel">
                                <el-col :span="14">
                                    <p v-if="userInfo.email">验证邮箱：<span style="color: #00a4e0;">{{
                                            userInfo.email | emailSafety
                                        }}</span>
                                        已验证</p>
                                    <p v-if="!userInfo.email">验证邮箱：未验证</p>
                                    <p style="color: #999999;">可用邮箱加密码登录恒点MOOL，可通过邮箱找回密码</p>
                                </el-col>
                                <el-col :span="10" style="text-align: right;">
                                    <el-button type="primary" plain="plain" size="mini"
                                               style="position: relative;top:30px;" @click="changeEmail()"
                                               v-if="userInfo.email">更换邮箱
                                    </el-button>
                                    <el-button type="primary" plain="plain" size="mini"
                                               style="position: relative;top:30px;" @click="setEmail()"
                                               v-if="!userInfo.email">设置邮箱
                                    </el-button>
                                </el-col>
                            </el-row>
                            <el-row class="infoPanel">
                                <el-col :span="14">
                                    <p>登录密码：已设置</p>
                                    <p style="color: #999999;">用于保护账号信息和登录安全</p>
                                </el-col>
                                <el-col :span="10" style="text-align: right;">
                                    <el-button type="primary" plain="plain" size="mini"
                                               style="position: relative;top:30px;" @click="changePwd()">更换密码
                                    </el-button>
                                </el-col>
                            </el-row>
                            <div v-if="thirdLoginQq || thirdLoginWx || thirdLoginWb">
                                <p class="pTitle" style="margin-top: 40px;">绑定第三方账号</p>
                                <el-row>
                                    <el-col :span="2" class="colImg" v-if="thirdLoginQq">
                                        <i class="iconfont icon-QQ third"
                                           :style="{backgroundColor: qqIsBinded ? '#3399ff' : '#D6D6DA'}"></i>
                                    </el-col>
                                    <el-col :span="3" v-if="thirdLoginQq">
                                        <span>QQ</span><br>
                                        <span class="spanBind">绑定账号</span>
                                    </el-col>
                                    <el-col :span="2" class="colImg" v-if="thirdLoginWx">
                                        <i class="iconfont icon-wechat-fill third"
                                           :style="{backgroundColor: wxIsBinded ? '#00cc00' : '#D6D6DA'}"></i>
                                    </el-col>
                                    <el-col :span="3" v-if="thirdLoginWx">
                                        <span>微信</span><br>
                                        <span class="spanBind">绑定账号</span>
                                    </el-col>
                                    <el-col :span="2" class="colImg" v-if="thirdLoginWb">
                                        <i class="iconfont icon-weibo1 third"
                                           :style="{backgroundColor: wbIsBinded ? '#ff6666' : '#D6D6DA'}"></i>
                                    </el-col>
                                    <el-col :span="3" v-if="thirdLoginWb">
                                        <span>微博</span><br>
                                        <span class="spanBind">绑定账号</span>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
        <el-dialog title="更换手机号" :visible.sync="dialogChangeMobile" width="500px" :closeOnClickModal="false">
            <p style="font-size: 14px;color: #999999;">更换手机号后您将无法使用此手机号进行找回密码及登录相关操作</p>
            <p style="color: #000000;">已绑定手机号：{{ userInfo.mobile | mobileSafety }}</p>
            <el-form>
                <el-form-item label="">
                    <el-input placeholder="短信验证码" style="width: 150px;margin-right: 10px;"
                              v-model="oldFormMobile.code"></el-input>
                    <el-button type="primary" plain="plain" @click="sendOldMobile">{{ sendBtnText }}</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changeMobileNext()">下一步</el-button>
            </div>
        </el-dialog>
        <el-dialog title="更换手机号" :visible.sync="dialogChangeMobileNext" width="500px" @opened="changeClose()"
                   :closeOnClickModal="false">
            <p style="font-size: 14px;color: #999999;">更换手机号后您将无法使用此手机号进行找回密码及登录相关操作</p>
            <sub-mobile ref="subMobile" @mobileSuccess="doMobileEnd" :type="1"></sub-mobile>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" plain="plain" @click="changeMobileCancel()">取消</el-button>
                <el-button type="primary" @click="changeMobileCommit()">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="更换邮箱" :visible.sync="dialogChangeEmail" width="500px" :closeOnClickModal="false">
            <p style="font-size: 14px;color: #999999;">更换邮箱后您将无法使用此邮箱进行找回密码及登录相关操作</p>
            <p style="color: #000000;">已绑定邮箱：{{ userInfo.email | emailSafety }}</p>
            <el-form :model="oldFormEmail">
                <el-form-item label="" prop="code">
                    <el-input placeholder="邮箱验证码" style="width: 150px;margin-right: 10px;"
                              v-model="oldFormEmail.code"></el-input>
                    <el-button type="primary" plain="plain" @click="sendChangeEmail">{{ sendBtnText }}</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changeEmailCancel()" plain="plain">取消</el-button>
                <el-button type="primary" @click="changeEmailNext()">下一步</el-button>
            </div>
        </el-dialog>
        <el-dialog title="设置邮箱" :visible.sync="dialogChangeEmailNext" width="500px" @opened="changeEmailCancel()"
                   :closeOnClickModal="false">
            <div style="margin-left: 30px;">
                <p style="font-size: 14px;color: #999999;">更换邮箱后您将无法使用此邮箱进行找回密码及登录相关操作</p>
                <el-form :model="formEmail">
                    <el-form-item label="" prop="email" :rules="[{
                required: true,
                message: '请输入邮箱地址',
                trigger: 'blur'
            }]">
                        <el-input placeholder="邮箱地址" style="width: 300px;" v-model="formEmail.email"></el-input>
                    </el-form-item>
                    <el-form-item label="" style="margin-top: 1em;">
                        <el-input placeholder="邮箱验证码" style="width: 150px;margin-right: 10px;"
                                  v-model="formEmail.code"></el-input>
                        <el-button type="primary" plain="plain" @click="sendEmailVerifyCode">{{
                                sendBtnText
                            }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changeEmailNextCancel()" plain="plain">取消</el-button>
                <el-button type="primary" @click="changeEmailCommit()">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改密码" :visible.sync="dialogChangePwd" width="500px" :closeOnClickModal="false">
            <el-form style="padding-top: 1.5em;margin-left: 80px;" ref="refFormPwd" :model="formChangePwd">
                <el-form-item label="" prop="oldPwd" :rules="[{
                required: true,
                message: '请输入原密码',
                trigger: 'blur'
            }]">
                    <el-input placeholder="原密码" style="width: 300px;" v-model="formChangePwd.oldPwd"
                              type="password"></el-input>
                </el-form-item>
                <el-form-item label="" prop="newPwd" :rules="[{
                required: true,
                message: '请输入新密码',
                trigger: 'blur'
            },{
                min: 6,
                max: 20,
                message: '密码长度6-20位，建议数字和字母组合',
                trigger: 'blur'
            }]">
                    <el-input placeholder="新密码" style="width: 300px;" v-model="formChangePwd.newPwd"
                              type="password"></el-input>
                </el-form-item>
                <el-form-item label="" prop="repeatPwd" :rules="[{
                required: true,
                message: '请再次输入密码',
                trigger: 'blur'
            }]">
                    <el-input placeholder="重复新密码" style="width: 300px;" v-model="formChangePwd.repeatPwd"
                              type="password"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changePwdCancel()" plain="plain">取消</el-button>
                <el-button type="primary" @click="changePwdCommit()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'
import SubMobile from '../public/sub/SubMobile'

export default {
    name: 'BindAndPassword',
    components: {
        HdHeader,
        HdFooter,
        HdAside,
        SubMobile
    },
    created () {
        this.getUserInfo()
        this.setCaptchaUrl()
        this.getConfig()
    },
    data () {
        return {
            userInfo: {},
            form: {},
            qqIsBinded: false,
            wxIsBinded: false,
            wbIsBinded: false,
            dialogChangeMobile: false,
            dialogChangeMobileNext: false,
            captchaImgUrl: '',
            dialogChangeEmail: false,
            dialogChangeEmailNext: false,
            dialogChangePwd: false,
            formChangePwd: {
                oldPwd: '',
                newPwd: '',
                repeatPwd: ''
            },
            oldFormEmail: {
                code: ''
            },
            formEmail: {
                email: '',
                code: ''
            },
            sendBtnText: '发送验证码',
            sendLimitTime: 0,
            oldFormMobile: {
                code: ''
            },
            thirdLoginWx: 0,
            thirdLoginQq: 0,
            thirdLoginWb: 0
        }
    },
    methods: {
        getConfig () {
            let that = this
            this.$ajax.get('/api/configsystem/getbynames', {
                params: {
                    'names': [
                        'third_login_wx',
                        'third_login_qq',
                        'third_login_wb'
                    ]
                }
            }).then(function (r) {
                Object.keys(r.data.items).forEach(function (key) {
                    let v = r.data.items[key]
                    switch (key) {
                        case 'register_type':
                            that.registerType = v
                            break
                        case 'third_login_wx':
                            that.thirdLoginWx = v
                            break
                        case 'third_login_qq':
                            that.thirdLoginQq = v
                            break
                        case 'third_login_wb':
                            that.thirdLoginWb = v
                            break
                    }
                })
            })
        },
        decBtnTime () {
            if (this.sendLimitTime === 0) {
                this.sendBtnText = '发送验证码'
            } else {
                this.sendLimitTime--
                this.sendBtnText = this.sendLimitTime + 'S'
                let that = this
                setTimeout(function () {
                    that.decBtnTime()
                }, 1000)
            }
        },
        decBtnTimeStop () {
            this.sendLimitTime = 0
            this.sendBtnText = '发送验证码'
        },
        getUserInfo () {
            let that = this
            this.$ajax.get('/api/user/get').then(function (r) {
                that.userInfo = r.data
            })
        },
        changeMobile () {
            this.decBtnTimeStop()
            this.oldFormMobile.code = ''
            this.dialogChangeMobile = true
        },
        changeClose () {
            this.dialogChangeMobile = false
        },
        changeMobileNext () {
            if (this.isEmpty(this.oldFormMobile.code)) {
                this.showError('请输入验证码')
                return
            }
            let that = this
            //校验手机号
            this.$ajax.post('/api/mobileverify/verify', {
                mobile: this.userInfo.mobile,
                code: this.oldFormMobile.code,
                type: 2
            }).then(function (r) {
                that.decBtnTimeStop()
                that.dialogChangeMobileNext = true
            })
        },
        setCaptchaUrl: function () {
            this.captchaImgUrl = this.baseUrl + '/api/captcha/get?t=' + Math.random()
        },
        changeMobileCancel () {
            this.$refs.subMobile.reInit()
            this.dialogChangeMobileNext = false
        },
        changeMobileCommit () {
            this.$refs.subMobile.checkMobile()
        },
        changeEmail () {
            this.oldFormEmail.code = ''
            this.decBtnTimeStop()
            this.dialogChangeEmail = true
        },
        changeEmailCancel () {
            this.dialogChangeEmail = false
        },
        sendChangeEmail () {
            if (this.sendLimitTime > 0) {
                return
            }
            this.formEmail.code = ''
            let that = this
            this.$ajax.post('/api/emailverify/send', {
                email: this.userInfo.email
            }).then(function (res) {
                that.sendLimitTime = 60
                that.decBtnTime()
            })
        },
        changeEmailNext () {
            if (this.isEmpty(this.oldFormEmail.code)) {
                this.showError('请输入验证码')
                return
            }
            let that = this
            this.$ajax.post('/api/emailverify/verify', {
                email: this.userInfo.email,
                code: this.oldFormEmail.code,
                type: 2
            }).then(function (r) {
                //设置默认显示名称
                that.sendLimitTime = 0
                that.formEmail.email = ''
                that.formEmail.code = ''
                that.dialogChangeEmailNext = true
            })
        },
        changeEmailNextCancel () {
            this.dialogChangeEmailNext = false
        },
        changeEmailCommit () {
            if (this.isEmpty(this.formEmail.email)) {
                this.showError('请输入邮箱')
                return
            }
            if (this.isEmpty(this.formEmail.code)) {
                this.showError('请输入邮箱验证码')
                return
            }
            this.formEmail.type = 1
            let that = this
            this.$ajax.post('/api/user/setemail', this.formEmail).then(function (r) {
                that.dialogChangeEmailNext = false
                //重新获取用户
                that.getUserInfo()
            })
        },
        setEmail () {
            this.decBtnTimeStop()
            this.formEmail.email = ''
            this.formEmail.code = ''
            this.dialogChangeEmailNext = true
        },
        changePwd () {
            this.formChangePwd.oldPwd = ''
            this.formChangePwd.newPwd = ''
            this.formChangePwd.repeatPwd = ''
            this.dialogChangePwd = true
        },
        changePwdCancel () {
            this.dialogChangePwd = false
        },
        changePwdCommit () {
            let that = this
            this.$refs.refFormPwd.validate((valid) => {
                if (valid) {
                    if (that.isEmpty(that.formChangePwd.oldPwd)) {
                        that.showError('请输入原密码')
                        return
                    }
                    if (that.isEmpty(that.formChangePwd.newPwd)) {
                        that.showError('请输入新密码')
                        return
                    }
                    if (that.formChangePwd.newPwd !== that.formChangePwd.repeatPwd) {
                        that.showError('两次密码不一致')
                        return
                    }
                    that.$ajax.post('/api/user/updatefieldpasswordforuser', {
                        password: that.formChangePwd.oldPwd,
                        new_password: that.formChangePwd.newPwd
                    }).then(function (r) {
                        that.dialogChangePwd = false
                        that.$message.success('密码修改成功，请重新登录，3秒后将跳转')
                        setTimeout(function () {
                            that.$ajax.get('/api/user/logout').then(function (r) {
                                that.$router.push({
                                    path: '/'
                                })
                            })
                        }, 3000)
                    })
                }
            })
        },
        sendEmailVerifyCode () {
            if (this.sendLimitTime > 0) {
                return
            }
            if (this.isEmpty(this.formEmail.email)) {
                this.showError('请输入邮箱')
                return
            }
            this.formEmail.code = ''
            let that = this
            this.$ajax.post('/api/emailverify/send', {
                email: this.formEmail.email
            }).then(function (res) {
                that.sendLimitTime = 60
                that.decBtnTime()
            })
        },
        setMobile () {
            this.decBtnTimeStop()
            this.dialogChangeMobileNext = true
        },
        doMobileEnd (mobile) {
            let that = this
            this.$ajax.post('/api/user/updatefieldmobile', {
                mobile: mobile
            }).then(function (r) {
                //重新获取用户信息
                that.getUserInfo()
                that.$refs.subMobile.reInit()
                that.dialogChangeMobileNext = false
            })
        },
        sendOldMobile () {
            if (this.sendLimitTime > 0) {
                return
            }
            let that = this
            this.$ajax.post('/api/mobileverify/send', {
                mobile: this.userInfo.mobile,
                type: 2
            }).then(function (r) {
                that.sendLimitTime = 60
                that.decBtnTime()
            })
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.pTitle {
    border-bottom: 1px solid #d6d6da;
    padding-bottom: 10px;
}

.infoPanel {
    box-shadow: 0px 2px 6px 0px #EEEEEE;
    border-radius: 5px;
    border: 1px solid #EEEEEE;
    padding: 20px;
    margin-top: 20px;
    font-size: 14px;
}

.colImg {
    text-align: right;
    padding-right: 10px;
    position: relative;
    top: 5px;
}

.spanBind {
    font-size: 14px;
    color: #999999;
    cursor: pointer;
}

.spanBind:hover {
    color: #00a4e0;
}

.third {
    font-size: 30px;
    padding: 5px;
    background-color: #D6D6DA;
    border-radius: 50%;
    color: #FFFFFF;
    margin-left: 25px;
    margin-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/BindAndPassword.vue